<div>
  Testing stubs available --
  <ul>
    <li><a routerLink="formula-bar">Formula bar link</a></li>
  </ul>
</div>
